import React, { useState } from 'react';
import styles from './TermsPrivacyCookieConsentApp.module.css';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

function TermsPrivacyCookieConsentApp() {
  /*const [cookieConsent, setCookieConsent] = useState(false);*/
  const [modalOpen, setModalOpen] = useState(false);

 /* const handleAcceptCookies = () => {
    setCookieConsent(true);
  };*/

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <div>
      <button className={styles.termsButton} onClick={toggleModal}>Read Terms & Privacy</button>
      {/* Modal with Terms of Use and Privacy Policy */}
      {modalOpen && (
        <div className={styles.modalOverlay} onClick={toggleModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h2 className={styles.modalHeader}>Terms of Use and Privacy Policy</h2>
            <p className={styles.modalText}><TermsOfService /></p>
            <p className={styles.modalText}><PrivacyPolicy /></p>
            <button onClick={toggleModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default TermsPrivacyCookieConsentApp;



